export default {
	name: "indexView", // 免费小课
	data() {
		return {
			navList: [],
			freeList: [],
			inputStr: "",
		};
	},
	watch: {},
	created() {
		const menuList = JSON.parse(localStorage.getItem("menuList"));
		if (menuList && menuList.data) {
			this.navList = menuList.data;
			console.log("this.navList", this.navList);
		}
	},
	async mounted() {
		await this.getFreeList();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getFreeList() {
			const dataRes = await this.$zkHttp.index$get_special({
				page: 1,
				limit: 100,
				price: 0,
			});
			this.freeList = dataRes;
		},
		gotoDetail(e) {
			this.$router.push({
				name: 'columnDetail',
				query: {
					parent: 'free',
					special_id: e.id
				}
			});
		}
	},
};